import React from 'react';
import { usePermissions } from '../../../hooks/usePermissions';

/**
 * PermissionGate Component
 * Conditionally renders children based on granular permissions
 * 
 * @param {string} permission - The permission key (e.g., 'recruitment', 'employee_management')
 * @param {string} action - The CRUD action ('read', 'create', 'update', 'delete')
 * @param {React.ReactNode} children - The content to render if permission is granted
 * @param {React.ReactNode} fallback - Optional content to render if permission is denied
 * @param {boolean} showFallback - Whether to show fallback content (default: false)
 */
const PermissionGate = ({
  permission,
  action = 'read',
  children,
  fallback = null,
  showFallback = false
}) => {
  const { hasPermission } = usePermissions();

  const permissions = Array.isArray(permission) ? permission : [permission];
  const hasAccess = permissions.some(perm => hasPermission(perm, action));

  if (hasAccess) {
    return <>{children}</>;
  }

  if (showFallback && fallback) {
    return <>{fallback}</>;
  }

  return null;
};

export default PermissionGate;

